export class Modal {
  constructor(opts) {
    Object.assign(this, opts);
    this._root = null;
    // Initialise all active purposes to false, then apply initialState on top
    const defaults = Object.fromEntries((opts.activePurposes ?? []).map((p) => [p, false]));
    this._state = { ...defaults, ...opts.initialState };
  }

  show() {
    const root = document.createElement('div');
    root.className = 'nc-modal';
    root.setAttribute('role', 'dialog');
    root.setAttribute('aria-modal', 'true');

    const content = document.createElement('div');
    content.className = 'nc-modal-content';

    const title = document.createElement('h2');
    title.className = 'nc-modal-title';
    title.textContent = this.texts.title;
    content.appendChild(title);

    for (const p of this.activePurposes) {
      const row = document.createElement('label');
      row.className = 'nc-purpose-row';
      const cb = document.createElement('input');
      cb.type = 'checkbox';
      cb.dataset.purpose = p;
      cb.checked = !!this._state[p];
      cb.disabled = (p === 'functional');
      cb.addEventListener('change', () => { this._state[p] = cb.checked; });

      const span = document.createElement('span');
      span.className = 'nc-purpose-label';
      span.textContent = this.texts.purposes[p] ?? p;
      row.append(cb, span);

      const vendorList = document.createElement('ul');
      vendorList.className = 'nc-vendor-list';
      for (const v of this.vendors.filter((x) => x.purpose === p)) {
        const li = document.createElement('li');
        li.className = 'nc-vendor';
        li.dataset.purpose = p;
        li.textContent = v.name;
        vendorList.appendChild(li);
      }
      content.append(row, vendorList);
    }

    if (this.policyPageUrl) {
      const a = document.createElement('a');
      a.className = 'nc-policy-link';
      a.href = this.policyPageUrl;
      a.textContent = this.texts.policyLink ?? 'Política de cookies';
      content.appendChild(a);
    }

    const actions = document.createElement('div');
    actions.className = 'nc-modal-actions';

    const acceptAll = document.createElement('button');
    acceptAll.type = 'button';
    acceptAll.className = 'nc-modal-accept-all nc-btn-equal';
    acceptAll.textContent = this.texts.accept;
    acceptAll.addEventListener('click', () => {
      const all = Object.fromEntries(this.activePurposes.map((p) => [p, true]));
      this.onSave?.(all);
      this.hide();
    });

    const save = document.createElement('button');
    save.type = 'button';
    save.className = 'nc-modal-save nc-btn-equal';
    save.textContent = this.texts.save;
    save.addEventListener('click', () => { this.onSave?.({ ...this._state }); this.hide(); });

    const revoke = document.createElement('button');
    revoke.type = 'button';
    revoke.className = 'nc-modal-revoke nc-btn-equal';
    revoke.textContent = this.texts.revoke;
    revoke.addEventListener('click', () => { this.onRevoke?.(); this.hide(); });

    actions.append(acceptAll, save, revoke);
    content.appendChild(actions);

    root.appendChild(content);
    document.body.appendChild(root);
    this._root = root;
    return this;
  }

  hide() {
    this._root?.remove();
    this._root = null;
  }
}
